import { state } from "cerebral"

export const currentMessage = (get) => {
  const messages = get(state`feedback.messages`)
  const [current] = messages.filter(({ dismissed }) => !dismissed)
  return current
}
